export default {
  SET_FORM_DATA(state, payload) {
    Object.keys(payload).forEach((item) => {
      state.form[item] = payload[item]
    })
  },
  RESTART(state) {
    setTimeout(() => {
      Object.assign(state.form, state.defaultForm)
      state.resultsFound = false
      state.topThree = []
      state.topPerGenre = []
      state.formResults = []
      state.activeLocation = null
    }, 1000)
  },
  SET_ABOUT_STATUS(state, payload) {
    state.showAbout = payload
  },
  SET_ACTIVE_LOCATION(state, payload) {
    state.activeLocation = payload
  },
  SET_TOP_THREE(state, payload) {
    state.topThree = payload
  },
  SET_TOP_PER_GENRE(state, payload) {
    state.topPerGenre.push(payload)
  },
  RESULTS_FOUND(state, payload) {
    state.resultsFound = payload
  },
  SET_RESULTS(state, payload) {
    state.formResults = payload
  }
}